import React from 'react'
import classNames from 'classnames'

import { TabItem } from './index'

interface IProps {
  list: TabItem[]
  currentTab: string
  handleTabClick: (e: React.MouseEvent) => void
}

const TabList = ({ list, currentTab, handleTabClick }: IProps) => {
  return (
    <div className="tab-list">
      {list.map(item => {
        const { chi_name, tab_name, dropdown_enter_name, dropdown_list } = item
        return (
          <div
            key={chi_name}
            data-name={tab_name}
            className={classNames('tab-item', {
              active: currentTab === tab_name,
            })}
            onClick={handleTabClick}
          >
            {chi_name}
          </div>
        )
      })}
      <style jsx>
        {`
          .tab-list {
            padding: 0 32px;
            z-index: 2;
            height: 48px;
            width: 672px;
            background-color: #1f2129;
            font-size: 18px;
            color: white;
            display: flex;
            border-radius: 2px;
          }
          .tab-item {
            position: relative;
            display: inline-block;
            height: 100%;
            margin-right: 32px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .tab-item:hover {
            font-weight: bold;
            color: #ffcc32;
          }
          .tab-item:last-of-type {
            margin-right: 0;
          }
          .tab-item.active {
            font-weight: bold;
            color: #ffcc32;
          }
          .tab-item.active::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 4px;
            background-color: #ffe100;
          }
        `}
      </style>
    </div>
  )
}

export default TabList
